import React, { useMemo } from 'react';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './DateField.css';

const toISO = (d) => {
  if (!d || isNaN(d.getTime())) return '';
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

export default function DateField({
  value,
  onChange,
  placeholder = 'ZZ.LL.AAAA',
  label,
  className = 'df-input',
  wrapperClassName = 'df-wrapper',
  ...rest
}) {
  const selected = useMemo(() => {
    if (!value) return null;
    const d = new Date(value + 'T00:00:00');
    return isNaN(d.getTime()) ? null : d;
  }, [value]);

  return (
    <ReactDatePicker
      selected={selected}
      onChange={(date) => onChange(toISO(date))}
      dateFormat="dd.MM.yyyy"
      placeholderText={placeholder}
      showMonthDropdown
      showYearDropdown
      dropdownMode="select"
      isClearable
      wrapperClassName={wrapperClassName}
      className={className}
      calendarClassName="df-calendar"
      {...rest}
    />
  );
}
